import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubCategory } from '../../model/subCategory';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class SubCategoryService {
  url = environment.API_URL;
  constructor(private http: HttpClient) { }

  getAll(): Observable<SubCategory[]>{
    return this.http.get<SubCategory[]>(`${this.url}business-subcategory`);
  }
  
  getSubcategoryById(id:number): Observable<SubCategory>{
    return this.http.get<SubCategory>(`${this.url}business-subcategoryByCategory/${id}`);
  }

  getById(id:number): Observable<SubCategory>{
    return this.http.get<SubCategory>(`${this.url}business-subcategory/${id}`);
  }
}
